<template>
  <div>
    <div class="d-flex align-center mb-2">
      <router-link :to="{name: 'storePurchasable'}" class="router-link">
        <v-icon color="grey darken-1" class="mr-3" size="32">mdi-arrow-left-circle</v-icon>
      </router-link>
      <h3 class="mb-0">Create New Purchasable</h3>
    </div>

    <NFTCreate>
      <template v-slot:top>
        <v-row>
          <v-col cols="12">
            <p class="text-14 mb-1">Purchasable Name *</p>
            <v-text-field
                v-model="createPurchasableForm.name"
                :rules="[rules.required]"
                outlined
                dense
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <p class="text-14 mb-1">Description *</p>
            <v-textarea
                v-model="createPurchasableForm.description"
                :rules="[rules.required]"
                outlined
            ></v-textarea>
          </v-col>

          <v-col cols="12" sm="6">
            <p class="text-14 mb-1">Price *</p>
            <v-text-field
                v-model="createPurchasableForm.price"
                :rules="[rules.required, rules.positive]"
                outlined
                dense
                type="number"
                @wheel="$event.target.blur()"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <p class="text-14 mb-1">Purchasable Max Supply *</p>
            <v-text-field
                v-model="createPurchasableForm.maxSupply"
                :rules="[rules.required, rules.positive]"
                outlined
                dense
                type="number"
                @wheel="$event.target.blur()"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:createBtn="{metadata, uploadNftMetadata}">
        <v-btn
            block
            dark
            color="indigo darken-3"
            :loading="createPurchasableLoading"
            @click="createHandle(metadata, uploadNftMetadata)"
        >Create</v-btn>
      </template>
    </NFTCreate>

    <!--  success dialog  -->
    <ConfirmationDialog
        :dialogShow="confirmationDialog"
        msg="Success to create new purchasable"
        status="success"
        :confirmationCallback="successCallback"
        btnName="Back"
    ></ConfirmationDialog>
  </div>
</template>

<script>
import ethCall from "@/lib/eth/ethCall/index"
import NFTCreate from '../Component/NftCreate'
import Vue from 'vue'
import {ethers} from "ethers";
import backendCall from "@/lib/backendCall";
import ethUtil from "@/lib/eth/util";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "PurchasableCreate",
  components: {
    ConfirmationDialog,
    NFTCreate
  },
  data(){
    return {
      createPurchasableForm: {
        name: "",
        description: "",
        price: null,
        maxSupply: null,
      },
      createPurchasableLoading: false,
      confirmationDialog: false,
      rules: {
        required: value => !!value || 'Required.',
        positive: value => parseInt(value) >= 0 || 'Positive number'
      }
    }
  },
  methods: {
    async createHandle(metadata, uploadNftMetadata){
      try {
        this.createPurchasableLoading = true
        const ipfsUrl = await uploadNftMetadata(metadata)
        if (ipfsUrl){
          const receipt = await ethCall.storeFactory.createPurchasable(
              this.createPurchasableForm.price,
              this.createPurchasableForm.maxSupply,
              ipfsUrl
          )
          console.log("Receipts: ", receipt)
          const iface = new ethers.utils.Interface(["event CreatePurchasable(address indexed store,uint256 purchasableId,uint256 tokenId,uint256 price,uint256 maxSupply)"])
          const log = iface.decodeEventLog("CreatePurchasable", receipt.logs[2].data)
          const purchasableId = parseInt(log.purchasableId._hex, 16)

          const purchasableInfo = {
            purchasableId,
            name: this.createPurchasableForm.name,
            description: this.createPurchasableForm.description
          }

          await backendCall.purchasable.updatePurchasableInfo(purchasableInfo)

          this.confirmationDialog = true
        } else {
          throw Error("Fail to create purchasable")
        }
        /* eslint-disable */
      }catch (e) {
        const revertMsg = ethUtil.errorMsgHandle(e.message)
        if (revertMsg) {
          e.message = revertMsg
        }
        Vue.notify({
          type: "error",
          text: e.message
        })
      }finally {
        this.createPurchasableLoading = false
      }
    },
    successCallback() {
      this.$router.push({name: 'storePurchasable'})
    }
  }
}
</script>

<style scoped>

</style>